<header-title [model]="headerTitle"></header-title>

<div class="row">
    <div class="col-md-1">
        <button class="btn btn-primary" type="button" [routerLink]="['/audit/add']">Add New Audit</button>
    </div>
</div>

<section class="panel">
    <div class="row">
        <div class="col col-md-6">
            <header class="panel-heading">
                <h2 class="panel-title">Existing Audits</h2>
            </header>
        </div>
        <div class="col col-md-6 pt-3">
            <div class="row" style="align-items:flex-end;">
                <div class="col col-md-2 text-right">
                    <label class=" control-label">Filter Audits:</label>
                </div>
                <div class="col-md-10">
                    <form [formGroup]="filterForm" *ngIf="filterForm">
                        <input type="text" class="form-control filter-input" formControlName="filterText" placeholder="Start typing to filter list" />
                    </form>
                </div>
            </div>
        </div>
    </div>
    <div class="panel-body">
        <div class="table-responsive">
            <table class="table table-hover mb-none">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Description</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let audit of auditList;index as i">
                        <td>{{i+1}}</td>
                        <td>{{audit.name}}</td>
                        <td>{{audit.description}}</td>
                        <td class="actions">
                            <a [routerLink]="['/audit', audit.id]" class="mb-1 mt-1 mr-2"><i class="fas fa-edit"></i></a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</section>
